import { supabase } from '@/lib/supabase/config';

export type IntegrationType = 'zapier';
export type IntegrationStatus = 'active' | 'expired';

export interface IntegrationToken {
  id: number;
  type: IntegrationType;
  title: string | null;
  created_at: string;
  expires_at: string;
  last_used_at: string | null;
  status: IntegrationStatus | null;
  organization_id: number;
}

export async function getActiveIntegrationTokens(
  organizationId: number,
): Promise<IntegrationToken[]> {
  const { data, error } = await supabase.rpc('get_org_integration_tokens', {
    p_org_id: organizationId,
    p_is_inactive: false,
  });

  if (error) {
    throw new Error(error.message || 'Failed to get active integration tokens');
  }

  return data as IntegrationToken[];
}

export async function getInactiveIntegrationTokens(
  organizationId: number,
): Promise<IntegrationToken[]> {
  const { data, error } = await supabase.rpc('get_org_integration_tokens', {
    p_org_id: organizationId,
    p_is_inactive: true,
  });

  if (error) {
    throw new Error(
      error.message || 'Failed to get inactive integration tokens',
    );
  }

  return data as IntegrationToken[];
}

export async function getActiveIntegrationTokensForProject(
  organizationId: number,
  projectId: number,
): Promise<IntegrationToken[]> {
  const { data, error } = await supabase.rpc('get_org_integration_tokens', {
    p_org_id: organizationId,
    p_project_id: projectId,
    p_is_inactive: false,
  });

  if (error) {
    throw new Error(
      error.message || 'Failed to get active integration tokens for project',
    );
  }

  return data as IntegrationToken[];
}
